import { BehaviorSubject } from 'rxjs';
import { throttle } from 'lodash';
import { API } from '../../api';
import { IBalance, IBalanceService } from './balance.type';

export const APP_TOP_UP_BASE_URL = '/profile/top-up';
export const APP_WITHDRAW_BASE_URL = '/profile/withdraw';
export const APP_TRANSFER_WALLET_URL = '/profile/transfer-wallet';

export const BalanceService$ = new BehaviorSubject<IBalanceService | null>({
  loading: false,
  balance: undefined,
});

export const refreshBalance = throttle(
  async (): Promise<void> => {
    BalanceService$.next({ ...BalanceService$.value, loading: true });
    return fetchMyBalance()
      .then((balance) => BalanceService$.next({ balance }))
      .finally(() => BalanceService$.next({ ...BalanceService$.value, loading: false }));
  },
  2000,
  { trailing: false },
);

export const requestTopUp = () => {
  window.location.href = APP_TOP_UP_BASE_URL;
};

export const requestWithdraw = () => {
  window.location.href = APP_WITHDRAW_BASE_URL;
};

export const requestTransferWallet = () => {
  window.location.href = APP_TRANSFER_WALLET_URL;
};

// Số dư top-nav lấy từ payment-service (NGUỒN CHÂN LÝ, cùng với trang Ví) — trước đây gọi endpoint legacy
// '/account/balances/me' (đã chết/404 trên gateway) nên top-nav kẹt ở giá trị cũ lúc login → lệch với Ví.
export const fetchMyBalance = () => {
  return API.get<{
    balance: number;
    available: number;
    locked: number;
    topUpBalance: number;
    incomeBalance: number;
  }>('/v1/payment-service/users/balance').then((res) => {
    const d = res.data || ({} as any);
    return {
      id: '',
      accountId: '',
      username: '',
      balance: d.balance ?? 0,
      bonusBalance: 0,
      turnoverAmt: 0,
      totalBettingAmt: 0,
      totalPayout: 0,
      onHoldAmt: d.locked ?? 0,
      availableBalance: d.available ?? d.balance ?? 0,
      bonusTicketBalance: 0,
      totalDeposit: 0,
      totalWithdrawal: 0,
      countDeposit: 0,
      countWithdrawal: 0,
      depositTurnoverAmt: 0,
      isBetting: false,
    } as IBalance;
  });
};

export const availableBalanceForWithdraw = (balance?: IBalance) => {
  if (!balance) return 0;
  return Math.max(
    0,
    (balance.balance >= balance.availableBalance ? balance.availableBalance - balance.bonusBalance : balance.balance) -
      balance.turnoverAmt,
  );
};
